import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import { createSelectorRx } from "keautils"
import { componentToRx } from "app/logic/rx";
import { addDate } from "keautils";
import { GuiaListMem } from "./listmem";
import { observeResource } from "kea-resource";
import * as globals from "app/resources/globals";
import { FiltroGuiaComponent } from "./filtro";

type Entity = models.GuiaDTO;

interface Props {
    permisos: models.Rol;
    Session: models.Session;
    IdSucursal: number;
    filtro: models.FiltroGuia;
    onFiltroChange: (x: models.FiltroGuia) => void;
}

/**Listado de todas las guias */
class GuiasListNoRx extends React.PureComponent<Props> {
    constructor(props) {
        super(props);
        const now = new Date();
        this.state = {
            filtro: {
                FechaInicio: addDate(now, "days", -3),
            }
        };
    }
    private botonFlag = false;
    private MemoryQuery = observeResource(resources.Guia.QueryInicial);
    private VerFiltroClienteOrigenEnConsultaGuias = (props: Props) => props.permisos.Guia.VerFiltroClienteOrigenEnConsultaGuias;
    private filtro = (props: Props) => 
    {
        return props.filtro;
    }
    
    private guias = createSelectorRx(this.filtro, filtro => {
        if (this.botonFlag) {
            this.botonFlag = false;
            this.MemoryQuery = observeResource(resources.Guia.QueryConsulta, filtro);
            return this.MemoryQuery;
        }
        else
        {return this.MemoryQuery}
    });

    handleOnLimpiar = async () => {
        await this.props.onFiltroChange({

            IdSucursalOrigen: undefined,
            IdSucursalDestino: undefined,

            IdSucursalStatus: undefined,
            EnSucursalOrigen: undefined,
            EnSucursalDestino: undefined,
            FechaInicio: undefined,
            FechaFinal: undefined,
            IdClienteDestino: undefined,
            IdClienteOrigen: undefined,
            Folio: "",
            StatusGuiaFacturacion: undefined,
            Status: undefined,
            CantPaquetes: undefined,
            CantSobres: undefined,
            FletePorCobrar: undefined,
            EntregaDomicilio: undefined,
            RecoleccionDomicilio: undefined,
            TipoAcuse: undefined,
            ImporteMayorCero: undefined,
            Limite: 100,

            EsCancelada: undefined,
            EsDeCredito: undefined,
            TipoSeguro:undefined


        });
    }

    enviar = async () => {
        this.botonFlag = true;
        
        //debugger;
        await this.props.onFiltroChange({

            IdSucursalDestino: this.props.filtro.IdSucursalDestino,
            IdSucursalOrigen: this.props.filtro.IdSucursalOrigen,

            IdSucursalStatus: this.props.filtro.IdSucursalStatus,
            EnSucursalOrigen: this.props.filtro.EnSucursalOrigen,
            EnSucursalDestino: this.props.filtro.EnSucursalDestino,
            FechaInicio: this.props.filtro.FechaInicio,
            FechaFinal: this.props.filtro.FechaFinal,
            IdClienteDestino: this.props.filtro.IdClienteDestino,
            IdClienteOrigen: this.props.filtro.IdClienteOrigen,
            
            Folio: this.props.filtro.Folio?.toString(),
            StatusGuiaFacturacion: this.props.filtro.StatusGuiaFacturacion,
            Status: this.props.filtro.Status,
            FletePorCobrar: this.props.filtro.FletePorCobrar,
            EntregaDomicilio: this.props.filtro.EntregaDomicilio,
            RecoleccionDomicilio: this.props.filtro.RecoleccionDomicilio,
            TipoAcuse: this.props.filtro.TipoAcuse,
            ImporteMayorCero: this.props.filtro.ImporteMayorCero,
            Limite: this.props.filtro.Limite,
            
            EsCancelada : this.props.filtro.EsCancelada,
            EsDeCredito : this.props.filtro.EsDeCredito,
            TipoSeguro: this.props.filtro.TipoSeguro
        });
    }

    render() {
        const guias = this.guias(this.props);
        const verFiltroClienteOrigen = this.VerFiltroClienteOrigenEnConsultaGuias(this.props);
        return (
            <div>
                <kea.Title titulo="Consulta de guías." onLimpiar={this.handleOnLimpiar} />
                <FiltroGuiaComponent value={this.filtro(this.props)} onChange={this.props.onFiltroChange} verClienteOrigen={verFiltroClienteOrigen} />
                <kea.Button  onClick={ this.enviar } style="primary" >Buscar</kea.Button>
                <GuiaListMem value={guias} cookieKey="ConsultaGuiasConsulta" />
            </div>
        )
    }
}

const GuiasLisRx = componentToRx(GuiasListNoRx);
/**Listado de todas las guias */
export class GuiaList2 extends React.PureComponent {
    render() {
        return <GuiasLisRx
            permisos={resources.User.PermisoRx}
            Session={resources.User.SessionRx}
            filtro={globals.state.map(x => x.filtroGuiasConsultaZE)}
            onFiltroChange={x => globals.setState({ filtroGuiasConsultaZE: x })}
            IdSucursal={resources.User.IdSucursalRx}
        />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/guias/list2/GuiaListConBoton.tsx